import { render, staticRenderFns } from "./ModalNewRule.vue?vue&type=template&id=6ad3f89d&"
import script from "./ModalNewRule.vue?vue&type=script&lang=js&"
export * from "./ModalNewRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports